export const contact = {
  title: 'BİZE ULAŞIN',
  
  // Contact Information
  info: {
    email: {
      label: 'E-POSTA',
      primary: 'concierge@lucendoelite.com',
      secondary: 'private@lucendoelite.com',
    },
    company: {
      label: 'ŞİRKET BİLGİLERİ',
      text: 'MİACCENDO GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ',
    },
    address: {
      label: 'ADRES',
      line1: 'Paradise AVM, Adnan Kahveci Mah.',
      line2: 'Yavuz Sultan Selim Blv. No:16 D:39,',
      line3: '34528 Beylikdüzü/İstanbul/Türkiye',
    },
  },
};
